import { useReducer, useEffect, useState } from "react";
import { getAsistenciaMedicaInitialState } from "../helpers/getAsistenciaMedicaInitialState";
import { obtenerDatosSocio } from "../helpers/socioPrincipal";
import { asistenciaMedicaReducer } from "../reducers/asistenciaMedicaReducer";
import { AuthInfo } from "../interfaces/ads/auth.info.interface";
import { StorageManager } from "../interfaces/ads/storage.manager.interface";
import { HttpRequestOptions } from "../interfaces/ads/http.request.options.interface";
import { AsistenciaMedicaActionType } from "../interfaces/global-state/asistencia.medica.action.type.enum";
import { ApiError } from "../interfaces/api.error.interface";
import { formatearError } from "../utils/apiUtils";
import { AsistenciaMedicaGlobalState } from "../interfaces/global-state/asistencia.medica.state.interface";
import { AsistenciaMedicaAction } from "../interfaces/global-state/asistencia.medica.action.interface";
import { Socio } from "../models/socioPrincipal.model";
import { useTheme } from "./useTheme";

// No modificar las props porque tambien lo usa ADS al hook 
export const useAsistenciaMedica = (
    user: AuthInfo,
    storageReady: boolean,
    storageManager: StorageManager | any,
    useRequest: () => { apiRequest: (options: HttpRequestOptions) => Promise<unknown> },
    setError?: any,
    tipoSocio?: string,
    IonicReact?: any,
    checkPermissions?: () => Promise<boolean>
): {asistenciaMedica: AsistenciaMedicaGlobalState, dispatchAsistenciaMedica: React.Dispatch<AsistenciaMedicaAction>, planPremium: string } => {

    const [asistenciaMedica, dispatchAsistenciaMedica] = useReducer(
        asistenciaMedicaReducer,
        getAsistenciaMedicaInitialState()
    );
    const [planPremium, setPlanPremium] = useState(undefined);

    const { apiRequest } = useRequest();
    const { fluxTheme } = useTheme();

    useEffect(() => {
        // Se ejecuta unicamente en entorno web
        if (setError) {
            setError(false)
            obtenerDatosSocio(Number(user.userInfo.interlocutorComercial), apiRequest, user)
                .then((socio: Socio) => {
                    setPlanPremium(JSON.parse(localStorage.getItem('plan')))
                    dispatchAsistenciaMedica({
                        type: AsistenciaMedicaActionType.actualizarUsuario,
                        socio: socio
                    });
                })
                .catch((error) => {
                    let errorAlInicializar: ApiError = formatearError(error);
                    sessionStorage.setItem("ASIS_MED_INIT_ERROR", JSON.stringify(errorAlInicializar));
                    /* Workaround para cuando el usuario ingresa al modulo antes de que se finalice la llamada a la API.
                    Permite que la pantalla principal se entere del error sin necesidad de salir y volver a ingresar al modulo.*/
                    // TODO: Reemplazar por suscripciones al estado de sessionStorage.
                    dispatchAsistenciaMedica({
                        type: AsistenciaMedicaActionType.actualizarUsuario,
                        socio: null
                    });
                    setError(true)
                })
        }
    }, [user]);

    useEffect(() => {
        if(planPremium !== '' || planPremium !== undefined) fluxTheme(planPremium);
    }, [planPremium])

    useEffect(() => {
        if(tipoSocio){
            dispatchAsistenciaMedica({
                type: AsistenciaMedicaActionType.actualizarTipoSocio,
                tipoSocio
            });
        }
    }, [tipoSocio] )

    useEffect(() => {

        dispatchAsistenciaMedica({
            type: AsistenciaMedicaActionType.actualizarAtencionesFinalizadas,
            casosFinalizados: []
        });

        dispatchAsistenciaMedica({
            type: AsistenciaMedicaActionType.actualizarControlVerdes,
            controlVerdes: []
        });

        dispatchAsistenciaMedica({
            type: AsistenciaMedicaActionType.actualizarTextoComponentes, 
            textoComponentes: []
        });
    }, []);

    return {
        asistenciaMedica,
        dispatchAsistenciaMedica,
        planPremium
    }
}